// Status → badge classes and calendar accent colours
const S = {
  // visit statuses
  Unscheduled: { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "#94A3B8" },
  Draft: { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "#94A3B8" },
  Proposed: { badge: "bg-sky-50 text-sky-700 border-sky-200", dot: "#0EA5E9" },
  "Awaiting Client Confirmation": { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  Confirmed: { badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "#10B981" },
  Published: { badge: "bg-teal-50 text-teal-700 border-teal-200", dot: "#1B9E8F" },
  Scheduled: { badge: "bg-blue-50 text-blue-700 border-blue-200", dot: "#3B82F6" },
  "In Progress": { badge: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "#6366F1" },
  Completed: { badge: "bg-green-50 text-green-700 border-green-200", dot: "#22C55E" },
  "Report Pending": { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  "Follow-Up Required": { badge: "bg-orange-50 text-orange-700 border-orange-200", dot: "#F97316" },
  "Ready for Invoicing": { badge: "bg-violet-50 text-violet-700 border-violet-200", dot: "#8B5CF6" },
  Invoiced: { badge: "bg-slate-100 text-slate-700 border-slate-300", dot: "#64748B" },
  Closed: { badge: "bg-slate-100 text-slate-500 border-slate-200", dot: "#94A3B8" },
  Cancelled: { badge: "bg-red-50 text-red-700 border-red-200", dot: "#EF4444" },
  Postponed: { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  "Unable to Complete": { badge: "bg-red-50 text-red-700 border-red-200", dot: "#EF4444" },
  // contract statuses
  Active: { badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "#10B981" },
  Suspended: { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  Expired: { badge: "bg-red-50 text-red-700 border-red-200", dot: "#EF4444" },
  "Renewal Due": { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  Archived: { badge: "bg-slate-100 text-slate-500 border-slate-200", dot: "#94A3B8" },
  // action statuses
  Open: { badge: "bg-sky-50 text-sky-700 border-sky-200", dot: "#0EA5E9" },
  "Waiting on Client": { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  Overdue: { badge: "bg-red-50 text-red-700 border-red-200", dot: "#EF4444" },
  // approval
  Pending: { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "#F59E0B" },
  Approved: { badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "#10B981" },
  // generic
  Disabled: { badge: "bg-red-50 text-red-700 border-red-200", dot: "#EF4444" },
};

export const PRIORITY = {
  Critical: "bg-red-100 text-red-700 border-red-200",
  High: "bg-orange-100 text-orange-700 border-orange-200",
  Normal: "bg-slate-100 text-slate-600 border-slate-200",
  Low: "bg-slate-50 text-slate-500 border-slate-200",
};

export const statusMeta = (s) => S[s] || { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "#94A3B8" };
export default S;
